import request from '@/utils/request.js'

// 员工列表
function employList(data) {
    return request({
        url: '/api/v1/tob/accounts',
        method: 'get',
        params:data
    })
}

// 员工添加
function employAdd(data) {
    return request({
        url: '/api/v1/tob/accounts',
        method: 'post',
        data
    })
}

// 员工修改
function employEdit(data) {
    return request({
        url: '/api/v1/tob/accounts/edit',
        method: 'post',
        data
    })
}

// 员工删除
function employDelete(data) {
    return request({
        url: '/api/v1/tob/accounts/del',
        method: 'post',
        data
    })
}



export default {
    employList,
    employAdd,
    employEdit,
    employDelete
}
